<template>
  <TabelaOSD
    :colunas="resolvedColumns"
    :linhas="table.rows"
    :carregando="table.isLoading"
    :total-linhas="table.totalRows"
    :pagina="pagination.page"
    :campo-ordenacao="pagination.sort"
    :ordem-ordenacao="pagination.order"
    :texto-tabela-vazia="$t('indicadoresNaoEncontrados')"
    :config-paginacao="{ chunk: 2, chunksNavigation: 'scroll', edgeNavigation: false }"
    @page-change="onPageChange"
    @sort-change="onSortChange"
    @reload="getCodigos"
  >
    <template #toolbar-actions>
      <CodigoParceiroExport :pagination="pagination" :headers="headers" :id-parceiro="idParceiro" />
    </template>
  </TabelaOSD>
</template>

<script>
import CodigoParceiroExport from './CodigoParceiroExport.vue';
import TabelaOSD from '@/modules/shared/components/tabelaOSD/TabelaOSD.vue';
import { getPaginatedCodigosData } from '@/modules/admin/parceiro/codigoParceiroService';
import { useToast } from 'vue-toastification';
import { i18n } from '@/modules/localization';
import { ref, computed } from 'vue';
import eventbus from '@/modules/core/services/eventbus';

export default {
  components: { TabelaOSD, CodigoParceiroExport },
  props: {
    idParceiro: { type: String, required: true },
  },
  data: () => ({
    table: {
      totalRows: 0,
      rows: [],
      columns: ref([
        {
          label: computed((_) => i18n.global.t('codigo')),
          field: 'codigo',
        },
        {
          label: computed((_) => i18n.global.t('parceiro')),
          field: 'nomeParceiro',
        },
        {
          label: computed((_) => i18n.global.t('empresa')),
          field: 'nomeEmpresa',
        },
      ]),
      mode: 'remote',
      class: 'osd-table',
      styleClass: 'vgt-table bordered condensed',
      compactMode: true,
      lineNumbers: true,
      paginationOptions: {
        perPage: 5,
        enabled: true,
        mode: 'pages',
        perPageDropdownEnabled: false,
        nextLabel: '>',
        prevLabel: '<',
        infoFn: (params) => `
      ${params.firstRecordOnPage} - ${params.lastRecordOnPage} de ${params.totalRecords}
      `,
      },
      sortOptions: {
        enabled: true,
        initialSortBy: { field: 'codigo', type: 'desc' },
      },
      isLoading: false,
    },
    pagination: {
      page: 1,
      sort: 'codigo',
      order: 'desc',
      search: '',
    },
  }),
  computed: {
    resolvedColumns() {
      return this.table.columns.map((column) => ({
        ...column,
        label: column.label?.value ?? column.label,
      }));
    },
    headers() { return this.resolvedColumns.map((column) => column.label); },
  },
  mounted() { eventbus.on('reload-codigo', this.reloadCodigos); },
  unmounted() { eventbus.off('reload-codigo', this.reloadCodigos); },
  methods: {
    updateParams(pagination) {
      this.pagination = { ...this.pagination, ...pagination };
    },
    onPageChange(page) {
      this.updateParams({ page });
      this.getCodigos();
    },
    onSortChange(field) {
      const nextOrder = this.pagination.sort === field && this.pagination.order === 'asc' ? 'desc' : 'asc';
      this.updateParams({
        page: 1,
        sort: field,
        order: nextOrder,
      });
      this.getCodigos();
    },
    onFilter(filters) {
      this.updateParams({ ...filters, page: 1 });
      this.getCodigos();
    },
    reloadCodigos() {
      this.updateParams({ page: 1 });
      this.getCodigos();
    },
    async getCodigos() {
      this.table.isLoading = true;
      if (this.idParceiro !== undefined && this.idParceiro !== null && this.idParceiro !== '') {
        try {
          const data = await getPaginatedCodigosData(this.pagination, this.idParceiro);
          this.table.rows = data.dados;
          this.table.totalRows = data.total;
        } catch (error) {
          useToast().error(ref(computed((_) => i18n.global.t('erroAoObterAsInfosDasEmpresas'))));
        }
      }
      this.table.isLoading = false;
    },
  },
};

</script>
